module.exports = __webpack_public_path__ + "static/img/3s-platform-img1.18d1103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img1.png
// module id = wtzt
// module chunks = 0